import {
    putFuelLoading,
    putFuelRequest,
    putFuelSuccess,
    putFuelReject,
    putFuelReset
} from "../../actions/fuel/put";

export const putFuel = (formData) => async (dispatch, getState) => {
    dispatch(putFuelLoading());
    try {
        const { data } = await putFuelRequest(formData, getState);
        dispatch(putFuelSuccess(data))
    } catch (error) {
        dispatch(putFuelReject(error))
    } finally {
        setTimeout(() => { dispatch(putFuelReset()) }, 3000);
    }
    return Promise.resolve();
};